function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@bydesign-ui/utils';
import React from 'react';
import { usePrefixCls } from '@byte-design/config';
export function Card(props) {
  var className = props.className,
      title = props.title,
      _props$innerLine = props.innerLine,
      innerLine = _props$innerLine === void 0 ? true : _props$innerLine,
      _props$bordered = props.bordered,
      bordered = _props$bordered === void 0 ? true : _props$bordered,
      _props$headStyle = props.headStyle,
      headStyle = _props$headStyle === void 0 ? {} : _props$headStyle,
      _props$bodyStyle = props.bodyStyle,
      bodyStyle = _props$bodyStyle === void 0 ? {} : _props$bodyStyle,
      _props$footerStyle = props.footerStyle,
      footerStyle = _props$footerStyle === void 0 ? {} : _props$footerStyle,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      footer = props.footer,
      children = props.children,
      extra = props.extra,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      others = _objectWithoutProperties(props, ["className", "title", "innerLine", "bordered", "headStyle", "bodyStyle", "footerStyle", "style", "footer", "children", "extra", "size"]);

  var cls = classnames(usePrefixCls('card', {
    bordered: bordered,
    'inner-line': innerLine,
    size: size
  }), className);
  var headCls = usePrefixCls('card-head');
  var titleCls = usePrefixCls('card-head-title');
  var extraCls = usePrefixCls('card-head-extra');
  var bodyCls = usePrefixCls('card-body', {
    'no-header': !title && !extra,
    'no-footer': !footer
  });
  var footerCls = usePrefixCls('card-footer');

  var renderHeader = function renderHeader() {
    if (!title && !extra) {
      return null;
    }

    return React.createElement("div", {
      className: headCls,
      style: headStyle
    }, title ? React.createElement("div", {
      className: titleCls
    }, title) : null, extra ? React.createElement("div", {
      className: extraCls
    }, extra) : null);
  };

  var renderFooter = function renderFooter() {
    if (!footer) {
      return null;
    }

    return React.createElement("div", {
      className: footerCls,
      style: footerStyle
    }, footer);
  };

  return React.createElement("div", Object.assign({
    className: cls,
    style: style
  }, others), renderHeader(), React.createElement("div", {
    className: bodyCls,
    style: bodyStyle
  }, children), renderFooter());
}